export const enum CurrentTransactionStateTab {
    Request,
    Response,
    SystemDecision,
    TransactionHistory,
    InNotifications,
    OutNotifications,
    BankingSdkLogging
}
